/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TestCaseVisibility } from './TestCaseVisibility';
import {
    TestCaseVisibilityFromJSON,
    TestCaseVisibilityFromJSONTyped,
    TestCaseVisibilityToJSON,
    TestCaseVisibilityToJSONTyped,
} from './TestCaseVisibility';
import type { ReviewDecision } from './ReviewDecision';
import {
    ReviewDecisionFromJSON,
    ReviewDecisionFromJSONTyped,
    ReviewDecisionToJSON,
    ReviewDecisionToJSONTyped,
} from './ReviewDecision';
import type { SubmissionResultStatus } from './SubmissionResultStatus';
import {
    SubmissionResultStatusFromJSON,
    SubmissionResultStatusFromJSONTyped,
    SubmissionResultStatusToJSON,
    SubmissionResultStatusToJSONTyped,
} from './SubmissionResultStatus';
import type { AcceptedBy } from './AcceptedBy';
import {
    AcceptedByFromJSON,
    AcceptedByFromJSONTyped,
    AcceptedByToJSON,
    AcceptedByToJSONTyped,
} from './AcceptedBy';
import type { TestCaseReadWithOutputs } from './TestCaseReadWithOutputs';
import {
    TestCaseReadWithOutputsFromJSON,
    TestCaseReadWithOutputsFromJSONTyped,
    TestCaseReadWithOutputsToJSON,
    TestCaseReadWithOutputsToJSONTyped,
} from './TestCaseReadWithOutputs';

/**
 * 
 * @export
 * @interface SubmissionResultReadFull
 */
export interface SubmissionResultReadFull {
    /**
     * 
     * @type {string}
     * @memberof SubmissionResultReadFull
     */
    submission_id: string;
    /**
     * 
     * @type {string}
     * @memberof SubmissionResultReadFull
     */
    test_case_id: string;
    /**
     * 
     * @type {SubmissionResultStatus}
     * @memberof SubmissionResultReadFull
     */
    status?: SubmissionResultStatus;
    /**
     * 
     * @type {number}
     * @memberof SubmissionResultReadFull
     */
    points?: number | null;
    /**
     * 
     * @type {AcceptedBy}
     * @memberof SubmissionResultReadFull
     */
    accepted_by?: AcceptedBy | null;
    /**
     * 
     * @type {boolean}
     * @memberof SubmissionResultReadFull
     */
    near_match?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof SubmissionResultReadFull
     */
    flagged_at?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof SubmissionResultReadFull
     */
    flag_comment?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubmissionResultReadFull
     */
    output_text: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubmissionResultReadFull
     */
    output_image_base64: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubmissionResultReadFull
     */
    diff_image_base64: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubmissionResultReadFull
     */
    error_text: string | null;
    /**
     * 
     * @type {number}
     * @memberof SubmissionResultReadFull
     */
    mismatch?: number | null;
    /**
     * 
     * @type {string}
     * @memberof SubmissionResultReadFull
     */
    matched_output_id?: string | null;
    /**
     * 
     * @type {ReviewDecision}
     * @memberof SubmissionResultReadFull
     */
    review?: ReviewDecision | null;
    /**
     * 
     * @type {string}
     * @memberof SubmissionResultReadFull
     */
    reviewed_by?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof SubmissionResultReadFull
     */
    reviewed_at?: Date | null;
    /**
     * 
     * @type {TestCaseReadWithOutputs}
     * @memberof SubmissionResultReadFull
     */
    test_case: TestCaseReadWithOutputs | null;
    /**
     * 
     * @type {TestCaseVisibility}
     * @memberof SubmissionResultReadFull
     */
    visibility: TestCaseVisibility;
    /**
     * 
     * @type {number}
     * @memberof SubmissionResultReadFull
     */
    max_points: number;
}



/**
 * Check if a given object implements the SubmissionResultReadFull interface.
 */
export function instanceOfSubmissionResultReadFull(value: object): value is SubmissionResultReadFull {
    if (!('submission_id' in value) || value['submission_id'] === undefined) return false;
    if (!('test_case_id' in value) || value['test_case_id'] === undefined) return false;
    if (!('output_text' in value) || value['output_text'] === undefined) return false;
    if (!('output_image_base64' in value) || value['output_image_base64'] === undefined) return false;
    if (!('diff_image_base64' in value) || value['diff_image_base64'] === undefined) return false;
    if (!('error_text' in value) || value['error_text'] === undefined) return false;
    if (!('test_case' in value) || value['test_case'] === undefined) return false;
    if (!('visibility' in value) || value['visibility'] === undefined) return false;
    if (!('max_points' in value) || value['max_points'] === undefined) return false;
    return true;
}

export function SubmissionResultReadFullFromJSON(json: any): SubmissionResultReadFull {
    return SubmissionResultReadFullFromJSONTyped(json, false);
}

export function SubmissionResultReadFullFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubmissionResultReadFull {
    if (json == null) {
        return json;
    }
    return {
        
        'submission_id': json['submission_id'],
        'test_case_id': json['test_case_id'],
        'status': json['status'] == null ? undefined : SubmissionResultStatusFromJSON(json['status']),
        'points': json['points'] == null ? undefined : json['points'],
        'accepted_by': json['accepted_by'] == null ? undefined : AcceptedByFromJSON(json['accepted_by']),
        'near_match': json['near_match'] == null ? undefined : json['near_match'],
        'flagged_at': json['flagged_at'] == null ? undefined : (new Date(json['flagged_at'])),
        'flag_comment': json['flag_comment'] == null ? undefined : json['flag_comment'],
        'output_text': json['output_text'],
        'output_image_base64': json['output_image_base64'],
        'diff_image_base64': json['diff_image_base64'],
        'error_text': json['error_text'],
        'mismatch': json['mismatch'] == null ? undefined : json['mismatch'],
        'matched_output_id': json['matched_output_id'] == null ? undefined : json['matched_output_id'],
        'review': json['review'] == null ? undefined : ReviewDecisionFromJSON(json['review']),
        'reviewed_by': json['reviewed_by'] == null ? undefined : json['reviewed_by'],
        'reviewed_at': json['reviewed_at'] == null ? undefined : (new Date(json['reviewed_at'])),
        'test_case': TestCaseReadWithOutputsFromJSON(json['test_case']),
        'visibility': TestCaseVisibilityFromJSON(json['visibility']),
        'max_points': json['max_points'],
    };
}

export function SubmissionResultReadFullToJSON(json: any): SubmissionResultReadFull {
    return SubmissionResultReadFullToJSONTyped(json, false);
}

export function SubmissionResultReadFullToJSONTyped(value?: SubmissionResultReadFull | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'submission_id': value['submission_id'],
        'test_case_id': value['test_case_id'],
        'status': SubmissionResultStatusToJSON(value['status']),
        'points': value['points'],
        'accepted_by': AcceptedByToJSON(value['accepted_by']),
        'near_match': value['near_match'],
        'flagged_at': value['flagged_at'] == null ? undefined : ((value['flagged_at'] as any).toISOString()),
        'flag_comment': value['flag_comment'],
        'output_text': value['output_text'],
        'output_image_base64': value['output_image_base64'],
        'diff_image_base64': value['diff_image_base64'],
        'error_text': value['error_text'],
        'mismatch': value['mismatch'],
        'matched_output_id': value['matched_output_id'],
        'review': ReviewDecisionToJSON(value['review']),
        'reviewed_by': value['reviewed_by'],
        'reviewed_at': value['reviewed_at'] == null ? undefined : ((value['reviewed_at'] as any).toISOString()),
        'test_case': TestCaseReadWithOutputsToJSON(value['test_case']),
        'visibility': TestCaseVisibilityToJSON(value['visibility']),
        'max_points': value['max_points'],
    };
}

